<template>
  <div ref="promptMessageTemplateRef" tabindex="-1">
    <strong>
      <UtilityText
        v-if="state === 'infilling'"
        class="font-neo-screen-head text-xl font-bold max-w-2/3 max-mobile:max-w-full"
        :text="$t('dbc-cancel-contract-command-prompt')"
      />
      <UtilityText
        v-if="state === 'validation'"
        class="font-neo-screen-head text-xl font-bold max-w-2/3 max-mobile:max-w-full"
        :text="$t('dbc-cancel-contract-validation-prompt')"
      />
      <UtilityText
        v-if="state === 'success'"
        class="font-neo-screen-head text-xl font-bold max-w-2/3 max-mobile:max-w-full"
        :text="cancellationCompletedPrompt"
      />
    </strong>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  state: CancelContractStates
}>()

const { t } = useI18n()

const client = useRuntimeConfig().public.client
const clientMap = useRuntimeConfig().public.clientMapping as ClientMapping

const promptMessageTemplateRef = ref<HTMLElement | null>(null)

const cancellationCompletedPrompt = ref(
  t('dbc-cancel-contract-completed-prompt')
)
cancellationCompletedPrompt.value = cancellationCompletedPrompt.value!.replace(
  '[placeholder]',
  clientMap[client]!
)

onUpdated(() => {
  promptMessageTemplateRef.value?.scrollIntoView()
  promptMessageTemplateRef.value?.focus()
})
</script>
